export const setNavigationOpened = (bool) => {
    return {
        type: 'SET_NAVIGATION_OPENED',
        payload: bool
    }
}